import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { useSellerPlanSimplificationVariant } from '../../hooks/use-seller-setting';
import { PlanSimplificationExperimentVariants } from '../../pages/settings/payment-and-subscription/constants';
import { PlanProfiles } from '../../enums/plan-profiles';

export const useEnableSimplifiedPlanGrid = () => {
  const { planProfileId } = useSelector(Global.selectSellerSubscriptionPlanInfo) ?? {};
  const planSimplificationVariant = useSellerPlanSimplificationVariant();
  const sellerSettingEnabled = planSimplificationVariant === PlanSimplificationExperimentVariants.VARIANT;
  const cutOffDateString = useFeatureFlag(FeatureFlagDeclarations.cutOffDateForSimplifiedPlanExperience);
  const sellerCreateDateUTCString = useSelector(Global.selectSellerCreateDateUTC);

  if (sellerSettingEnabled) {
    return true;
  }

  if (planProfileId !== PlanProfiles.byoa_billing_2023_q2.id) {
    return false;
  }

  try {
    const cutOffDate = new Date(cutOffDateString);
    const isNewSeller = new Date(sellerCreateDateUTCString) > cutOffDate;
    return isNewSeller;
  } catch {
    return false;
  }
};
